<ul class="row-container">
    <div class="alarm-row text">
        <li class="td font">
            <div>
                {{ alarm.channel }}
            </div>
        </li>
        <li class="td font">
            <div>{{ alarm.name }}</div>
        </li>
        <li class="td td-status font">
            <app-alarm-status-icon
                [statusText]="alarm.level"
            ></app-alarm-status-icon>
            <div>{{ alarm.status }}</div>
        </li>
        <li class="td font">
            <div>{{ alarm.value }}</div>
        </li>
        <li class="td td-btn">
            <button (click)="emitShowDetail()" class="border">
                {{ "alarm.button.details" | translate | uppercase }}
            </button>
        </li>
    </div>
</ul>
